import React from 'react';
import styled from 'styled-components';
import {proto,url} from '../../Helpers/api';
import Tabela, {TabelaLinha as TL} from '../../Common/Tabela';
import Celula from '../../Common/Celula';
import { MesExtenso } from '../../Helpers/date';
import MoreInfo from './index';

const TabelaLinha = styled(TL)`
  grid-template-columns: 40px 280px;
`

export default function MIAdmissoes (props) {
  const { dados={} } = props;
  const { empresa, mes, ano } = dados;
  return (
    <MoreInfo
      titulo={empresa}        
      subtitulo={`Admissões (${MesExtenso(mes-1)}/${ano})`}
      modalData={dados}
      f={{
        url: `${proto}://${url}/main/metricas/pessoal/admissoes`,
        opt: {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ empresa, mes, ano })
        },
      }}
    >
    {data => data && (
      <Tabela>
        <TabelaLinha header>
          <Celula>Dia</Celula>
          <Celula>Nome</Celula>
        </TabelaLinha>
        {data.map(e => {
          return (
            <TabelaLinha>
              <Celula>{e.dia}</Celula>
              <Celula>{e.nome}</Celula>
            </TabelaLinha>
          )
        })}
      </Tabela>
    )}
    </MoreInfo>
  )
}
